import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function toNumber(value) {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return isNaN(value) ? 0 : value;
  
  // Convert string
  const str = String(value).trim();
  if (str === '') return 0;
  
  // Replace comma with dot, remove non-numeric chars except dot/minus
  // Allow "320 cm" -> "320"
  const cleanStr = str.replace(/,/g, '.').replace(/[^\d.-]/g, '');
  
  const num = parseFloat(cleanStr);
  return isNaN(num) ? 0 : num;
}
